import s from './style/home.module.scss';
import { useEffect, useState } from 'react';

import { inject, observer } from 'mobx-react';
import withRouter from '@/components/withRouter';
import { Ellipsis, Mask } from 'antd-mobile';
import GrtImage from '@/components/GrtImage';
import aiImg from '@/assets/images/mobile/ai.webp';
import vectorImg from '@/assets/images/mobile/vector.webp';
import { Display } from '@/components/Display/Display';
import agengBgImg from '@/assets/images/mobile/agent_bg.webp';
import agengActionImg from '@/assets/images/mobile/agent_button.webp';
import { Storage } from '@/utils/Storage';
import Error from '@/components/Mobile/Error';
import GrtLoading from '@/components/Mobile/GrtLoading/GRTLoading';
const MobileOutsideHome = (props) => {
    const [open, setOpen] = useState(false);
    const { getAgentList, state } = props.store.grtAi;
    const { agentList = [], loading } = state;
    const onClick = (item) => {
        props.navigate(`/mobile/o/${item.id}/chat`);
    };
    useEffect(() => {
        getAgentList();
    }, []);
    useEffect(() => {
        let maskTip = Storage.get('maskTip', false);
        if (!maskTip) {
            setOpen(true);
            Storage.set('maskTip', 'true', false);
        }
    }, []);
    return (
        <div className={s['box-wrap']}>
            <Mask opacity="thick" visible={open}>
                <div className={s['mask-content']} direction="vertical">
                    <img className={s['agent-bg']} src={agengBgImg} alt="" />
                    <img
                        onClick={() => {
                            setOpen(false);
                        }}
                        className={s['agent-action']}
                        src={agengActionImg}
                        alt=""
                    />
                </div>
            </Mask>
            <Display show={loading}>
                <GrtLoading></GrtLoading>
            </Display>
            <Display show={!loading}>
                <Display show={agentList.length === 0}>
                    <Error></Error>
                </Display>
                <Display show={agentList.length}>
                    <div className={s['header']}>智教通</div>
                    <div className={s['title']}>
                        <GrtImage className={s['ai-img']} src={aiImg}></GrtImage>
                        <div>
                            智能体推荐
                            <GrtImage className={s['checked']} src={vectorImg}></GrtImage>
                        </div>
                    </div>
                    <div className={s['list-wrap']}>
                        {agentList.map((ele, index) => {
                            return (
                                <div
                                    className={s['list-item']}
                                    key={index}
                                    onClick={() => {
                                        onClick(ele);
                                    }}
                                >
                                    <GrtImage src={ele.agent_icon}></GrtImage>
                                    <div className={s['text-wrap']}>
                                        <div className={s['text-name']}> {ele.name}</div>
                                        <div className={s['text-des']}>
                                            <Ellipsis content={ele.description || ''}></Ellipsis>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </Display>
            </Display>
        </div>
    );
};
export default withRouter(inject('store')(observer(MobileOutsideHome)));
